import { createAsyncThunk } from '@reduxjs/toolkit';
import { notifyUser } from 'shared/errorHandling/ErrorToast/errorHandling';
import { AppDispatch, RootState } from 'store';
import { addKeyToReactItem } from 'store/mappers/sharedMapper';
import { DispatchError } from 'store/slices/authSlice';
import SprintLengthAction from 'types/project/enums/SprintLength';
import EditSprintLengthDto from 'types/PrpTable/dto/EditSprintLengthDto';
import EditSprintLengthFormDto from 'types/PrpTable/dto/EditSprintLengthFormDto';
import sprintLengthApiService from 'api/sprintLengthApiService';

const updateSprintLength = createAsyncThunk<
  EditSprintLengthDto,
  EditSprintLengthFormDto,
  {
    dispatch: AppDispatch;
    state: RootState;
    rejectValue: DispatchError;
  }
>(SprintLengthAction.UPDATE_SPRINT_LENGTH, async (data: EditSprintLengthFormDto) => {
  const response = await sprintLengthApiService.updateSprintLength(data);
  if (!response) notifyUser();
  return addKeyToReactItem(response);
});
export default updateSprintLength;
